export default {
  total: 'Всего:',
  itemsPerPage: 'по',
} as const;
